import React from 'react';
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { Typography, Space, Card } from 'antd';
import { useParams } from "react-router-dom";
import { _T } from "../../../../base-react/src/Localization";
import { Loading } from '../../../../base-react/components/Loading';
import { useCompetition } from '../../../../base-react/hooks/Competition';
import { CheckinTimeEdit } from './components/CheckinTimeEdit';
import { CheckinReport } from './components/CheckinReport';
import { CheckinToolbar } from './components/CheckinToolbar';
import { CheckinOrganizations } from './components/CheckinOrganizations';
const { Title } = Typography;
export const Checkin = () => {
    let { competition_id } = useParams();
    const [inputCompetition, event, competitions, loadingCompetition, , canEdit] = useCompetition(competition_id);
    if (loadingCompetition) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('checkin.title')))),
        React.createElement(BodyContainer, null,
            React.createElement(Space, { orientation: "vertical" },
                React.createElement(Title, { level: 2 }, _T('common.settings')),
                React.createElement(Card, null,
                    React.createElement(CheckinTimeEdit, { item: inputCompetition, disabled: !canEdit })),
                React.createElement(Title, { level: 2 }, _T('checkin.cancellations')),
                React.createElement(CheckinReport, { competition_id: competition_id }),
                React.createElement(Title, { level: 2 }, _T('checkin.title')),
                React.createElement(CheckinToolbar, { competition: inputCompetition, disabled: !canEdit }),
                React.createElement(CheckinOrganizations, { competition: inputCompetition, disabled: !canEdit })))));
};
